import { SettingsLayout } from '@agentic-flow-studio/shared/components/settings/SettingsLayout';
import type { SettingsNavItem } from '@agentic-flow-studio/shared/components/settings/SettingsSidebar';
import { SlidersHorizontal } from 'lucide-react';
import { pushDriver } from '@/lib/push';
import { authClient, getBetterAuthToken } from '@/utils/betterAuth';

const skillViperNavItems: SettingsNavItem[] = [
  {
    id: 'features',
    label: 'Features',
    icon: SlidersHorizontal,
    to: 'features',
    description: 'Turn feature areas on or off',
    adminOnly: true,
  },
];

export default function Settings() {
  return (
    <SettingsLayout
      productKey="anchor_contact"
      productLabel="Skill Viper"
      pushDriver={pushDriver}
      customNavItems={skillViperNavItems}
      getAuthToken={getBetterAuthToken}
      authClient={authClient}
      showDiagnostics={import.meta.env.DEV}
    />
  );
}
